import React, { useEffect, useState } from 'react';
import './Accommodation.css';
import { useTranslation } from 'react-i18next';
import backgroundImage from '../../images/accomodation_bckg.jpg';
import Accomodation1 from '../../images/accomodation_1.jpg';
import Accomodation2 from '../../images/accomodation_2.jpg';
import Accomodation3 from '../../images/accomodation_3.jpg';

const Planning = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    const sections = document.querySelectorAll('.section-content');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="home-container">
      {/* Image de fond fixe */}
      <div className="background-image" style={{ backgroundImage: `url(${backgroundImage})` }}></div>

      {/* Contenu superposé à l'image */}
      <div className="overlay-section">
        <h1 className="overlay-title">
          {t("accommodation.title")}
        </h1>
      </div>

      <div id="content">
        <div className="section section-1 center">
          <div className="accommodation-card">
            <img src={Accomodation1} alt="Accomodation 1" className="accommodation-card-img" />
              <p className="accommodation-card-title">
                Sol i Vida Hotel
              </p>

              <div style={{ marginTop: 10, display: 'flex', justifyContent: 'center' }}>
                <button
                  className="btn"
                  onClick={() => {
                    window.open(
                      "https://www.booking.com/hotel/es/sol-i-vida-adults-only.fr.html?aid=311090&label=rh-portocristo-d_L%2Aj34i1uFyOa7v4tpqJwSM199843821970%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-392681950%3Alp1005518%3Ali%3Adem%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YcGt_tphEo8pawEozW2KQ80-gYbCBTF%401736627673&sid=d4d67c3a86bc60461d1c9b48ea59891d&all_sr_blocks=418575201_127386432_2_1_0_471331&checkin=2025-06-28&checkout=2025-06-29&dest_id=-397271&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=418575201_127386432_2_1_0_471331&hpos=1&matching_block_id=418575201_127386432_2_1_0_471331&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&sr_pri_blocks=418575201_127386432_2_1_0_471331_22320&srepoch=1737394251&srpvid=7c177a9aca0800c6&type=total&ucfs=1&",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  {t("accommodation.buttons.0.label")}
                </button>
              </div>
          </div>

          <div className="accommodation-card">
            <img src={Accomodation2} alt="Accomodation 2" className="accommodation-card-img" />
              <p className="accommodation-card-title">
                Aparthotel Marina Drach
              </p>

              <div style={{ marginTop: 10, display: 'flex', justifyContent: 'center' }}>
                <button
                  className="btn"
                  onClick={() => {
                    window.open(
                      "https://www.booking.com/hotel/es/aparthotel-marina-drach.fr.html?aid=311090&label=rh-portocristo-d_L%2Aj34i1uFyOa7v4tpqJwSM199843821970%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-392681950%3Alp1005518%3Ali%3Adem%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YcGt_tphEo8pawEozW2KQ80-98BvQk%401736627638&sid=d4d67c3a86bc60461d1c9b48ea59891d&all_sr_blocks=701778002_288734489_2_1_0&checkin=2025-06-28&checkout=2025-06-29&dest_id=-397271&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=701778002_288734489_2_1_0&hpos=1&matching_block_id=701778002_288734489_2_1_0&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&sr_pri_blocks=701778002_288734489_2_1_0__19920&srepoch=1737394447&srpvid=52527b855b070410&type=total&ucfs=1&",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  {t("accommodation.buttons.0.label")}
                </button>
              </div>
          </div>

          <div className="accommodation-card">
            <img src={Accomodation3} alt="Accomodation 3" className="accommodation-card-img" />
              <p className="accommodation-card-title">
                THB Felip
              </p>

              <div style={{ marginTop: 10, display: 'flex', justifyContent: 'center' }}>
                <button
                  className="btn"
                  onClick={() => {
                    window.open(
                      "https://www.booking.com/hotel/es/thb-felip.fr.html?aid=311090&label=rh-portocristo-d_L%2Aj34i1uFyOa7v4tpqJwSM199843821970%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-392681950%3Alp1005518%3Ali%3Adem%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YcGt_tphEo8pawEozW2KQ80-brhpZc%401736627658&sid=d4d67c3a86bc60461d1c9b48ea59891d&all_sr_blocks=9428710_187405696_0_34_0_251188&checkin=2025-06-28&checkout=2025-06-29&dest_id=-397271&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=9428710_187405696_0_34_0_251188&hpos=1&matching_block_id=9428710_187405696_0_34_0_251188&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&sr_pri_blocks=9428710_187405696_0_34_0_251188_22660&srepoch=1737394341&srpvid=03ce7b4fd9be05e3&type=total&ucfs=1&",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  {t("accommodation.buttons.0.label")}
                </button>
              </div>
          </div>

        </div>


      </div>

    </div>
  );
};

export default Planning;